import type { SaRole } from '@/mocks/saRolesPermissions';

interface Props {
  roles: SaRole[];
}

export default function RoleStatsBar({ roles }: Props) {
  const activeRoles = roles.filter((r) => r.active);
  const disabledRoles = roles.filter((r) => !r.active);
  const totalPermissions = roles.reduce((sum, r) => sum + r.permissions.reduce((s, p) => s + p.actions.length, 0), 0);
  const criticalCount = roles.filter((r) => r.criticalPermissions.length > 0 && r.active).length;
  const systemRoles = roles.filter((r) => r.isSystem);
  const customRoles = roles.filter((r) => !r.isSystem);

  const stats = [
    { label: 'Total Roles', value: roles.length, icon: 'ri-shield-user-line', color: 'text-foreground-950' },
    { label: 'Activos', value: activeRoles.length, icon: 'ri-check-line', color: 'text-emerald-600' },
    { label: 'Inactivos', value: disabledRoles.length, icon: 'ri-pause-circle-line', color: 'text-foreground-400' },
    { label: 'Sistema', value: systemRoles.length, icon: 'ri-settings-4-line', color: 'text-amber-600' },
    { label: 'Personalizados', value: customRoles.length, icon: 'ri-brush-line', color: 'text-violet-600' },
    { label: 'Permisos Configurados', value: totalPermissions, icon: 'ri-key-2-line', color: 'text-sky-600' },
    { label: 'Con Acceso Crítico', value: criticalCount, icon: 'ri-alert-line', color: 'text-rose-600' },
  ];

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-2.5">
      {stats.map((s) => (
        <div
          key={s.label}
          className="bg-background-50 border border-background-200 rounded-2xl p-3.5 flex flex-col gap-1.5 hover:border-background-300 transition-colors cursor-default"
        >
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 rounded-lg bg-background-100 flex items-center justify-center">
              <i className={`${s.icon} ${s.color} text-xs`}></i>
            </div>
            <span className="text-[10px] text-foreground-400 font-medium uppercase tracking-wider whitespace-nowrap">{s.label}</span>
          </div>
          <span className="text-foreground-950 font-bold text-lg leading-none pl-9">{s.value}</span>
        </div>
      ))}
    </div>
  );
}